<template>
  <div id="wrapper">
    <div id="page-wrapper" class="light-gray-bg dashbard-1" v-if="isMatchPath">
          <!-- MainView -->
      <article v-on:click.self="open = false, detail=''" :class="{ 'full-column' : !open }" class="wrapper wrapper-content main-column">
         <!-- ViewTitleBox -->
        <div class="ibox-tools view-title">
            <h1 class="info-menu view-name">
                <img src="static/img/assets/nav_1on1_on.png" alt="">
                <span v-if="this.$route.params.item">{{$t('popTitleStr9')}}
                <sidebar-nav-link :isedit='this.isEdit'></sidebar-nav-link>
                </span>
                <span v-else>{{$t('oneOnRegTitle')}}</span>
            </h1>
            <span class="info-right">
            </span>
        </div>
        <!-- /ViewTitleBox -->
        <section class="animated fadeInRight">
          <div class="ibox">
            <form @submit.prevent  class="ibox-content">
              <!-- 期限 -->
              <regist-limit :view="view" :dueDate="this.dueDate" />
              <!-- /期限 -->
              <regist-partner :view = "view" @reset-partner="resetPartner" @open-partner="setDetail" :partner="this.oneItem.partner" />
              <regist-public :view = "view" @delete-public-user="deletePublicUser" @delete-public-group="deletePublicGroup" @delete-public-org="deletePublicOrg" @reset-public="resetSelectPublic" @open-public="setDetail" :checkedUsers="this.checkedUsers" :checkedGroups="this.checkedGroups" :checkedOrgs="this.checkedOrgs"/>
              <!-- /公開設定 -->
              <template >
                <!-- 誇れること -->
                <div v-for="count  in checkContent1on1" :key="count.id" class="ibox-child">
                  <div class="row">
                    <div class="form-group col-sm-12">
                      <label class="control-label">{{contentTitle[count-1]}}</label>
                      <textarea v-model="oneItem.contents[count-1]" class="form-control" :placeholder="contentTitle.input[count-1]" rows="3"></textarea>
                    </div>
                  </div>
                </div>
                <!-- /誇れること -->
                <div class="container row">
                  <p v-if="!$v.oneItem.contents[0].contentValidation" class="text-danger font-bold col-sm-12">{{$t('orderLessThanOneItemStr')}}</p>
                </div>
                <!-- メモ -->
                <div class="ibox-child">
                  <div class="row">
                    <div class="form-group col-sm-12">
                      <label class="control-label">{{$t('fiveContent1on1')}}</label>
                      <textarea v-model="oneItem.memo" class="form-control" :placeholder="$t('inputMyMemoStr')" rows="6"></textarea>
                    </div>
                  </div>
                </div>
                <!-- メモ -->
                <!-- 誇れること -->
                <!-- <div class="ibox-child">
                  <div class="row">
                    <div class="form-group col-sm-12">
                      <label class="control-label">{{$t('secContent1on1')}}</label>
                      <textarea v-model="oneItem.contents[0]" class="form-control" :placeholder="$t('inputPrideStr')" rows="3"></textarea>
                    </div>
                  </div>
                </div> -->
                <!-- /誇れること -->
                <!-- 気づき -->
                <!-- <div class="ibox-child">
                  <div class="row">
                    <div class="form-group col-sm-12">
                      <label class="control-label">{{$t('thirdContent1on1')}}</label>
                      <textarea  v-model="oneItem.contents[1]" class="form-control" :placeholder="$t('inputNoticedStr')" rows="3"></textarea>
                    </div>
                  </div>
                </div> -->
                <!-- /気づき -->
                <!-- 次へのアクション -->
                <!-- <div class="ibox-child">
                  <div class="row">
                    <div class="form-group col-sm-12">
                      <label class="control-label">{{$t('fourContent1on1')}}</label>
                      <textarea  v-model="oneItem.contents[2]" class="form-control" :placeholder="$t('inputNextActionStr')" rows="3"></textarea>
                    </div>
                  </div>
                </div> -->
                <!-- /次へのアクション -->
                <!-- <div class="row">
                  <span v-if="!$v.oneItem.contents[0].contentValidation" class="text-danger font-bold col-sm-12">{{$t('orderLessThanOneItemStr')}}</span>
                </div> -->
                <!-- 個人用メモ -->
                <!-- <div class="ibox-child">
                  <div class="row">
                    <div class="form-group col-sm-12">
                      <label class="control-label">{{$t('fiveContent1on1')}}</label>
                      <textarea v-model="oneItem.memo" class="form-control" :placeholder="$t('inputMyMemoStr')" rows="6"></textarea>
                    </div>
                  </div>
                </div> -->
                <!-- /個人用メモ -->
                <!-- ボタン -->
                <div class="ibox-child">
                  <div class="row okr-regist-btnset">
                    <div class="col-lg-4 col-md-4 col-sm-4"><button @click="regist1on1" type="button" class="btn btn-success block m-b" :disabled="checkRegistering">{{$t('saveStr')}}</button></div>
                    <div class="col-lg-4 col-md-4 col-sm-4"><button @click="cancel1on1" type="button" class="btn btn-primary block m-b" :disabled="checkRegistering">{{$t('popTitleStr2Type')}}</button></div>
                    <div class="col-lg-4 col-md-4 col-sm-4"><button @click="onClickCancel" type="button" class="btn btn-danger block m-b">{{ $t('cancelStr') }}</button></div>
                  </div>
                </div>
                <!-- /ボタン -->
              </template>
            </form>
          </div>
        </section>
      </article>
      <!-- DetailView -->
      <div id="detailView" class="sub-column" :class="{ 'sub-active' : open }">
        <div class="close-content"><div @click="open = false" class="close-btn cursor"><i class="fa fa-angle-right"></i></div></div>
        <article class="sub-content-wrap">
          <section class="inner-wrap">
            <div class="s-inner-wrap">
              <div class="ibox-title flex-box fl-between ibox-detail-header">
                <span v-if="detail == 'public'" class="info-menu flex-box">{{$t('publicSettingLabelTitle')}}</span>
                <span v-else-if="detail == 'partner'" class="info-menu flex-box">{{$t('partnerSettingLabelTitle')}}</span>
                <span class="info-right"></span>
              </div>
              <!-- Public -->
              <public-setting-detail-view v-if="detail == 'public'"
                :checkedOrgs="checkedOrgs"
                :checkedGroups="checkedGroups"
                :checkedUsers="checkedUsers"
                @updateGroups="onClickGroups"
                @updateOrganization="onClickOrg"
                @updateUsers="onClickUsers"
                ref="publicSetting"/>
              <div v-else-if="detail == 'partner'" class="ibox">
                <div class="ib-sub-content">
                  <div class="tabs-container">
                    <div class="ibox-title search-box">
                      <div class="row">
                          <div class="col-sm-12">
                              <div class="input-group">
                                  <input type="text" v-model="searchText" class="typeahead_2 form-control" :placeholder="$t('searchWithUserNameOrGroupNameStr')">
                              </div>
                          </div>
                      </div>
                    </div>
                    <div class="search-resultview">
                      <ul v-if="searchText == ''">
                        <li><label>{{$t('checkUserStrType')}}</label></li>
                        <li v-if="getVisitedUsers.length === 0"><label>{{$t('notFoundUserStr')}}</label></li>
                        <div>
                          <li v-for="user in getVisitedUsers" :key="user.id" v-if="user && user.userInfo && user.userId !== getUserId"><label>
                            <input type="radio" v-model="oneItem.partner" :value="user.userId" class="checkbox public-check">
                            <span class="search-userimg">
                              <img v-if="user.userInfo.userIcon" :src="user.userInfo.userIcon" alt="image" class="img-circle">
                              <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
                            </span>
                            <div class="search-userinfo">
                              <span class="search-username">{{ user.userInfo.userName }}</span>
                              <span class="search-userdept">{{ user.userInfo.dept }}</span>
                            </div>
                            <span class="check-mark"></span>
                          </label></li>
                        </div>
                      </ul>
                      <ul v-else>
                        <li v-if="Object.keys(this.getUsersBySearchText).length === 0"><label>{{$t('notFoundUserStr')}}</label></li>
                        <div v-for="(user, key) in getUsersBySearchText" :key="user.id" v-if="user && user.userInfo">
                          <li v-if="key !== getUserId"><label>
                            <input type="radio" v-model="oneItem.partner" v-bind:value="key" class="checkbox public-check">
                            <span class="search-userimg">
                              <img v-if="user.userInfo.userIcon" :src="user.userInfo.userIcon" alt="image" class="img-circle">
                              <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
                            </span>
                            <div class="search-userinfo">
                              <span class="search-username">{{ user.userInfo.userName }}</span>
                              <span class="search-userdept">{{ user.userInfo.dept }}</span>
                            </div>
                            <span class="check-mark"></span>
                          </label></li>
                        </div>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </section>
      </article>
    </div>
  </div>
</div>
</template>

<script>
import RegistLimit from '@/components/Regist/RegistLimit'
import RegistPublic from '@/components/Regist/RegistPublic'
import RegistPartner from '@/components/Regist/RegistPartner'
import { mapActions, mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
import SidebarNavLink from '@/components/Sidebar/SidebarNavLink'
import { content1on1 } from '@/main'
import PublicSettingDetailView from '@/components/DetailView/PublicSettingDetailView'
function contentValidation () {
  // console.log('validate', Object.values(this.oneItem.contents).filter(x => !x).length)
  if (Object.values(this.oneItem.contents).filter(x => x.trim().replace(/\r?\n/g, '').length === 0).length < 4) {
    return true
  } else {
    return false
  }
}

export default {
  name: 'OneRegist',
  mixedins: [validationMixin],
  components: {
    RegistLimit,
    RegistPublic,
    SidebarNavLink,
    RegistPartner,
    PublicSettingDetailView
  },
  data: function () {
    return {
      tag: 'regist',
      view: '1on1',
      open: false,
      detail: '',
      dueDate: new Date(),
      searchText: '',
      groups: {},
      checkedGroups: [],
      checkedUsers: [],
      checkedOrgs: [],
      oneItem: {
        contents: {
          0: '',
          1: '',
          2: '',
          3: ''
        },
        limitedAccess: {},
        memo: '',
        partner: '',
        date: new Date()
      },
      id: this.$route.params.id,
      isDraft: false,
      isEdit: false,
      beforeDate: new Date(),
      content1on1: content1on1,
      isRegistering: false
    }
  },
  validations: {
    oneItem: {
      contents: {
        0: { contentValidation },
        1: { contentValidation },
        2: { contentValidation }
      }
    }
  },
  computed: {
    isMatchPath () {
      return this.$route.name === 'OneRegist'
    },
    checkRegistering () {
      return this.isRegistering
    },
    ...mapGetters([
      'getUserId',
      'getCurrentUser',
      'getCurrentUserInfo'
    ]),
    ...mapGetters('ones/', [
      'getCurrentDraft1on1s',
      'getCurrent1on1sDate'
    ]),
    ...mapGetters('comments/', [
      'getCommentsByItemId'
    ]),
    ...mapGetters('groups/', [
      'getCurrentGroupsByText',
      'getOnlyGroupsBySearchText',
      'getGroupsByText',
      'getGroupsByIds',
      'getCurrentGroups',
      'getGroups'
    ]),
    ...mapGetters('users/', [
      'getUsersByText',
      'getUsersByIds',
      'getUsers'
    ]),
    ...mapGetters('organizations/', [
      'getOnlyOrganizationsByText'
    ]),
    ...mapGetters('_meta/', [
      'getMetaIsDeleted'
    ]),
    contentTitle () {
      return {
        0: this.$t('firstContent1on1'),
        1: this.$t('secondContent1on1'),
        2: this.$t('thirdContent1on1'),
        3: this.$t('forthContent1on1'),
        input: {
          0: this.$t('firstInputContent'),
          1: this.$t('secondInputContent'),
          2: this.$t('thirdInputContent'),
          3: this.$t('forthInputContent')
        }
      }
    },
    checkContent1on1 () {
      return Object.keys(content1on1.content1on1).length
    },
    getVisitedUsers: function () {
      const currentUser = this.getCurrentUser
      console.log('currentUser', currentUser)
      if (currentUser && currentUser.hasOwnProperty('visitHistory')) {
        console.log('in if getVisit')
        // return this.getUsersByIds(Object.keys(currentUser.visitHistory))
        const visitHistory = Object.keys(currentUser.visitHistory || [])
        const recentlyCheckedUsers = this.getUsersByIds(Object.keys(currentUser.visitHistory))
        let sortedRecentlyCheckedUsers = visitHistory.sort((a, b) => { return currentUser.visitHistory[b] - currentUser.visitHistory[a] })
          .filter(key => !this.getMetaIsDeleted(key))
          .map(x => { return recentlyCheckedUsers[x] })
        console.log(sortedRecentlyCheckedUsers)
        return sortedRecentlyCheckedUsers
      } else {
        console.log('in else getVisit')
        return {}
      }
    },
    getGroupsBySearchText: function () {
      return this.getOnlyGroupsBySearchText(this.searchText)
    },
    getUsersBySearchText: function () {
      if (this.searchText.length === 0) {
        return this.getUsers
      } else {
        return this.getUsersByText(this.searchText)
      }
    // },
    // getCDR: function () {
    //   if (
    },
    getOrganizationsBySearchText: function () {
      if (this.searchText.length === 0) {
        return this.getOnlyOrganizationsByText('')
      } else {
        return this.getOnlyOrganizationsByText(this.searchText)
      }
    }
  },
  // beforeMount: function () {
  //   this.groups = this.getGroups
  //   if (this.$route.params.item) {
  //     // from edit
  //     this.isEdit = true
  //     this.dueDate = new Date(this.$route.params.item.date)
  //     this.beforeDate = this.$route.params.item.date
  //     // if (this.$route.params.item.limitedAccess && this.$route.params.item.limitedAccess.limitedGroup) {
  //     //   this.checkedGroup = this.$route.params.item.limitedAccess.limitedGroup
  //     // }
  //     // } else if (Object.keys(this.getCurrentDraft1on1s).filter(x => !this.getCurrentDraft1on1s[x] ? false : this.getCurrentDraft1on1s[x].contents).length > 0) {
  //     //   const CD1on1s = this.getCurrentDraft1on1s
  //     //   for (let x of Object.keys(CD1on1s)) {
  //     //     if (CD1on1s[x].date) {
  //     //       const date = new Date(CD1on1s[x].date)
  //     //       this.dueDate = date
  //     //     }
  //     //   }
  //     // }
  //   } else if (Object.keys(this.getCurrentDraft1on1s).filter(x => !this.getCurrentDraft1on1s[x] ? false : this.getCurrentDraft1on1s[x].contents).length > 0) {
  //     const CD1on1s = this.getCurrentDraft1on1s
  //     console.log('oneregist.vue', CD1on1s)
  //     for (let x of Object.keys(CD1on1s)) {
  //       if (CD1on1s[x].date) {
  //         const date = new Date(CD1on1s[x].date)
  //         this.dueDate = date
  //         var str = date.getFullYear() + '/' +
  //         ('0' + (date.getMonth() + 1)).slice(-2) + '/' +
  //         ('0' + date.getDate()).slice(-2)
  //         this.oneItem.date = str
  //       }
  //     }
  //   } else {
  //     this.dueDate = new Date()
  //   }
  // },
  // beforeUpdate: function () {
  //   if
  // },
  mounted: function () {
    const $t = this.$t
    if (this.isRegistering) {
      this.isRegistering = false
    }
    if (this.$route.params.item) {
      // edit
      this.isEdit = true
      let date = new Date(this.$route.params.item.date)
      console.log(date)
      this.beforeDate = date
      this.dueDate = date
      // console.log('higehigepool', this.checkContent1on1)
      // let content = this.checkContent1on1
      for (let count = 0; count < this.checkContent1on1; count++) {
        // console.log(count, this.$route.params.item.contents[count])
        this.oneItem.contents[count] = this.$route.params.item.contents[count]
      }
      if (this.$route.params.item.partner) {
        this.oneItem.partner = this.$route.params.item.partner
      }
      this.oneItem.memo = this.$route.params.item.memo
      if (this.$route.params.item.limitedAccess) {
        if (this.$route.params.item.limitedAccess.limitedUsers) {
          this.checkedUsers = Object.keys(this.$route.params.item.limitedAccess.limitedUsers)
        }
        if (this.$route.params.item.limitedAccess.limitedGroups) {
          let allGroups = this.getGroupsByIds(Object.keys(this.$route.params.item.limitedAccess.limitedGroups))
          let groupIds = Object.keys(allGroups).filter(x => !allGroups[x].isOrganization)
          let orgIds = Object.keys(allGroups).filter(x => allGroups[x].isOrganization)
          this.checkedGroups = groupIds
          this.checkedOrgs = orgIds
        }
      }
    } else if (Object.keys(this.getCurrentDraft1on1s).filter(x => !this.getCurrentDraft1on1s[x] ? false : this.getCurrentDraft1on1s[x].contents).length > 0) {
      // draft
      console.log('------- in draft ---------')
      this.$swal({
        title: $t('comfirmMakeFromDraftStr'),
        type: 'question',
        showCancelButton: true,
        reverseButtons: false,
        cancelButtonColor: '#f64846',
        confirmButtonClass: 'btn btn-success',
        cancelButtonClass: 'btn btn-danger',
        animation: false,
        customClass: 'animated fadeInUp',
        // customClass: 'animated flipInX',
        width: '35rem',
        position: 'center',
        // toast: true,
        allowOutsideClick: false,
        padding: '2rem'
        // timer: 4000
      }).then((result) => {
        if (result.value) {
          this.isDraft = true
          const CD1on1s = this.getCurrentDraft1on1s
          for (let x of Object.keys(CD1on1s)) {
            if (CD1on1s[x].date) {
              for (let i = 0; i < CD1on1s[x].contents.length; i++) {
                this.oneItem.contents[i] = CD1on1s[x].contents[i]
              }
              let date = new Date(CD1on1s[x].date)
              this.beforeDate = date
              this.dueDate = date
              console.log('this.dueDate', this.dueDate)
              this.oneItem.memo = CD1on1s[x].memo
              if (CD1on1s[x].limitedAccess.limitedUsers) {
                this.checkedUsers = Object.keys(CD1on1s[x].limitedAccess.limitedUsers)
              }
              if (CD1on1s[x].limitedAccess.limitedGroups) {
                this.checkedGroups = Object.keys(CD1on1s[x].limitedAccess.limitedGroups)
              }
              // if (Object.keys(CD1on1s[x].limitedAccess).filter(x => x === 'limitedUsers').length > 0) {
              //   this.checkedUsers = Object.keys(CD1on1s[x].limitedAccess.limitedUsers)
              //   this.tabIndex = 0
              // } else {
              //   this.checkedGroup = CD1on1s[x].limitedAccess.limitedGroup
              //   this.tabIndex = 1
              // }
            }
          }
        } else {
          // キャンセル押下時は当日の日付が入る
          this.dueDate = new Date()
        }
      })
    } else {
      this.dueDate = new Date()
    }
  },
  methods: {
    ...mapActions('peoples', {
      setVisit: 'SET_VISIT_HISTORY'
    }),
    ...mapActions('ones/', {
      // VuexFireからのActionを読み込み
      setNewOne: 'SET_NEW_ONE',
      setNewOneDate: 'SET_NEW_ONEDATE',
      setDrafts1on1s: 'SET_DRAFTS_1ON1S',
      removeDrafts1on1s: 'REMOVE_DRAFTS_1ON1S',
      removeOneDate: 'REMOVE_ONEDATE'
    }),
    onClickGroups: function (value) {
      this.checkedGroups = value
    },
    onClickOrg: function (value) {
      this.checkedOrgs = value
    },
    onClickUsers: function (value) {
      this.checkedUsers = value
    },
    resetSelectPublic: function () {
      this.checkedUsers = []
      this.checkedGroups = []
      this.checkedOrgs = []
      this.$refs.publicSetting.resetCheckings()
    },
    deletePublicUser: function (userId) {
      let targetIndex = this.checkedUsers.indexOf(userId)
      this.checkedUsers.splice(targetIndex, 1)
    },
    deletePublicGroup: function (groupId) {
      let targetIndex = this.checkedGroups.indexOf(groupId)
      this.checkedGroups.splice(targetIndex, 1)
    },
    deletePublicOrg: function (orgId) {
      let targetIndex = this.checkedOrgs.indexOf(orgId)
      this.checkedOrgs.splice(targetIndex, 1)
    },
    resetPartner: function () {
      this.oneItem.partner = ''
    },
    setDetail (value) {
      console.log('parent methods clear')
      if (!this.open) {
        this.open = true
        this.detail = value
      } else if (this.open && this.detail === value) {
        this.open = false
      } else {
        this.detail = value
      }
    },
    // onClickGroupRadioButton (e) {
    //   console.log('checkedGroup, e', this.checkedGroups, e.target.value)
    //   if (e.target.value === this.checkedGroups) {
    //     this.checkedGroups = []
    //   }
    // },
    newOne: function () {
      // let regist = this.setNewOne
      let item = this.oneItem
      const oneItemId = this.id
      console.log('oneItemId', oneItemId)
      if (this.checkedUsers.length > 0) {
        item.limitedAccess.limitedUsers = this.parseArrayToObject(this.checkedUsers)
      }
      if (this.oneItem.partner) {
        if (!(this.$route.params.item && (this.oneItem.partner === this.$route.params.item.partner))) {
          this.setVisit(this.oneItem.partner)
        }
      }
      if (this.checkedGroups.length > 0 || this.checkedOrgs.length > 0) {
        let Groups = this.checkedGroups
        if (this.checkedOrgs.length > 0) {
          Groups = Groups.concat(this.checkedOrgs)
        }
        item.limitedAccess.limitedGroups = this.parseArrayToObject(Groups)
      }
      if (!oneItemId) {
        if (this.isDraft) {
          this.removeDrafts1on1s(this.getUserId)
          this.isDraft = false
        }
        this.setNewOne(this.oneItem)
        this.setNewOneDate(this.oneItem.date)
      } else {
        var editItem = {
          item: item,
          itemId: oneItemId
        }
        this.removeOneDate(this.formatDateToString(this.beforeDate))
        this.setNewOne(editItem)
        this.setNewOneDate(item.date)
        this.isEdit = false
      }
      this.$router.push('/one/list')
    },
    cancel1on1: function () {
      const $t = this.$t
      if (this.$v.oneItem.contents[0].contentValidation) {
        var str = this.formatDateToString(this.dueDate)
        this.oneItem.date = str
        let setDraft = this.setDrafts1on1s
        let item = this.oneItem
        if (this.checkedUsers) {
          item.limitedAccess.limitedUsers = this.parseArrayToObject(this.checkedUsers)
        }
        if (this.checkedGroups) {
          item.limitedAccess.limitedGroups = this.parseArrayToObject(this.checkedGroups)
        }
        // console.log(Object.keys(this.getCurrentDraft1on1s).filter(x => !this.getCurrentDraft1on1s[x] ? false : this.getCurrentDraft1on1s[x].contents))
        if (Object.keys(this.getCurrentDraft1on1s).filter(x => !this.getCurrentDraft1on1s[x] ? false : this.getCurrentDraft1on1s[x].contents).length > 0) {
          this.$swal({
            // sweetAlartの処理
            title: $t('popTitleStrType'),
            text: $t('popMessageStr2Type'),
            showCancelButton: true,
            cancelButtonColor: '#f64846',
            type: 'warning',
            confirmButtonClass: 'btn btn-success',
            cancelButtonClass: 'btn btn-danger',
            reverseButtons: false,
            animation: false,
            customClass: 'animated fadeInUp',
            // customClass: 'animated flipInX',
            width: '35rem',
            position: 'center',
            // toast: true,
            allowOutsideClick: false,
            padding: '2rem'
            // timer: 4000
          }).then((result) => {
            if (result.value) {
              // okが押下されたら
              console.log('true')
              setDraft(item)
              this.$swal({
                title: $t('compStorageStr'),
                type: 'success',
                animation: false,
                customClass: 'animated fadeInUp',
                // customClass: 'animated flipInX',
                width: '35rem',
                position: 'center',
                // toast: true,
                padding: '2rem',
                timer: 3000
              })
              this.$router.push('/one/list')
            } else {
              // cancelが押下されたら
              console.log('false')
              this.$router.push('/one/regist')
            }
          })
        } else {
          setDraft(item)
          this.$swal({
            title: this.$t('compStorageStr'),
            type: 'success',
            animation: false,
            customClass: 'animated fadeInUp',
            // customClass: 'animated flipInX',
            width: '35rem',
            position: 'center',
            // toast: true,
            padding: '2rem',
            timer: 3000
          })
          this.$router.push('/one/list')
        }
      } else {
        this.$swal({
          text: $t('orderContentsInputStr'),
          type: 'warning',
          animation: false,
          customClass: 'animated fadeInUp',
          // customClass: 'animated flipInX',
          width: '35rem',
          position: 'center',
          // toast: true,
          padding: '2rem',
          timer: 4000
        })
      }
    },
    regist1on1: function () {
      if (this.$v.oneItem.contents[0].contentValidation && this.dueDate) {
        this.isRegistering = true
        var dateStr = this.formatDateToString(this.dueDate)
        // this.oneItem.date = str
        // this.oneItem.date = this.dueDate
        this.oneItem.date = dateStr
        console.log('dateStr', dateStr)
        this.newOne()
      } else if (!this.$v.oneItem.contents[0].contentValidation) {
        this.$swal({
          text: this.$t('orderContentsInputStr'),
          type: 'warning',
          animation: false,
          customClass: 'animated fadeInUp',
          // customClass: 'animated flipInX',
          width: '35rem',
          position: 'center',
          // toast: true,
          padding: '2rem',
          timer: 4000
        })
      } else {
        this.$swal({
          text: this.$t('noDayStr'),
          type: 'warning',
          animation: false,
          customClass: 'animated fadeInUp',
          // customClass: 'animated flipInX',
          width: '35rem',
          position: 'center',
          // toast: true,
          padding: '2rem',
          timer: 4000
        })
      }
    },
    onClickCancel: function () {
      const $t = this.$t
      this.$swal({
        title: $t('popTitleStrType'),
        text: $t('confirmInputDeleteStr'),
        showCancelButton: true,
        cancelButtonColor: '#f64846',
        type: 'warning',
        confirmButtonClass: 'btn btn-success',
        cancelButtonClass: 'btn btn-danger',
        reverseButtons: false,
        animation: false,
        customClass: 'animated fadeInUp',
        // customClass: 'animated flipInX',
        width: '35rem',
        position: 'center',
        // toast: true,
        allowOutsideClick: false,
        padding: '2rem'
        // timer: 4000
      }).then((result) => {
        if (result.value) {
          this.$router.push('/one/list')
        } else {
          console.log('false')
        }
      })
    },
    parseArrayToObject: function (array) {
      let obj = {}
      for (const i in array) {
        obj[array[i]] = 1
      }
      return obj
    },
    formatDateToString: function (date) {
      var dt = date
      var str = dt.getFullYear() + '-' +
      ('0' + (dt.getMonth() + 1)).slice(-2) + '-' +
      ('0' + dt.getDate()).slice(-2)
      return str
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/one/OneRegist.vue